import { render, staticRenderFns } from "./NsNotificationBox.vue?vue&type=template&id=57ff335d&scoped=true&"
import script from "./NsNotificationBox.vue?vue&type=script&lang=js&"
export * from "./NsNotificationBox.vue?vue&type=script&lang=js&"
import style0 from "./NsNotificationBox.vue?vue&type=style&index=0&id=57ff335d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ff335d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NsNotification: require('/usr/app/src/components/ns/NsNotification.vue').default})
